import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PercentagePipe} from '../../../../pipes/percentage/percentage.pipe';

@Component({
  selector: 'app-doughnut-chart-label',
  templateUrl: './doughnut-chart-label.component.html',
  styleUrls: ['./doughnut-chart-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PercentagePipe]
})
export class DoughnutChartLabelComponent {
  @Input() label: string;
  @Input() labelColor: string;
  @Input() percentage: number;
  @Output() labelClick = new EventEmitter<string>();

  onLabelClicked(): void {
    this.labelClick.emit(this.label);
  }
}
